import * as React from 'react';
import { useState, useEffect } from 'react';
import SwipeableViews from 'react-swipeable-views';

import PropTypes from 'prop-types';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import { Box, AppBar } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';

//Redux
import { useSelector, useDispatch } from "react-redux";
import { SET_CALCULATOR  } from '../../redux/actions/types';

//My Components
import Slider from 'src/components/applications/Slider'
import PayTerm from 'src/components/applications/PayTerm'


const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    padding: theme.spacing(2),
  },
  margin: {
    height: theme.spacing(3),
  },
  tabText: {
    fontSize: '12px',
    [theme.breakpoints.down('md')]: {
      fontSize: '10px',
    },
  }
}));



function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 2, overflowX: 'hidden' }}>
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}

export default function BasicTabs() {
  const classes = useStyles();
  const theme = useTheme();

  const dispatch = useDispatch();
  const { user } = useSelector(state => state.auth);
  const [value, setValue] = useState(0);
  const [term, setTerm] = useState({});
  const [values, setValues] = useState({
    principal: 1000,
    term: 1,
    rate: 1
  });




  const handlePayTerms = prop => event => {
    setValues({...values, [prop]: event})
    dispatch({
      type: SET_CALCULATOR,
      payload: { term: event }
    })
  }

  const handleAmount = (data) => {
    setValues({...values, principal: data})
    dispatch({
      type: SET_CALCULATOR,
      payload: { principal: data }
    })
  }



  const handleChange = (event, newValue) => {
    setValue(newValue);
    let obj = newValue === 0 ? {
      rateTerm: 'Weekly',
      rate: term.weeklyRate,
      term: 1
    } : newValue === 1 && {
      rateTerm: 'Semi-monthly',
      rate: term.smRate,
      term: 1
    };
    setValues({...values, ...obj})
    dispatch({type: SET_CALCULATOR, payload: obj})
  };


  useEffect(() => {
    if(user && user.loanTerm){
      let trm = user.loanTerm;
      setTerm(user.loanTerm)
      let lt = user.loanTerm;
      let obj = {
        rateTerm: value === 0 ? 'Weekly' : 'Semi-monthly',
        rate: value === 0 ? trm.weeklyRate : trm.smRate,
        term: 1,
        principal: values.principal
      }
      dispatch({type: SET_CALCULATOR, payload: obj});
    }
  }, [user])


  console.log(values)
  return (
    <div className={`${classes.root}`}>

        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="secondary"
          textColor="inherit"
          variant="fullWidth"
          aria-label="full width tabs example"
        >
          <Tab label={<><span id="discrete-slider-always" className={`${classes.tabText} text-center text-primary`}>
        Weekly
      </span>
      <Typography id="discrete-slider-always" className="text-center" variant="caption">
       { Number(term.weeklyRate * 100).toFixed(1)}%
      </Typography></>} {...a11yProps(0)} />
          <Tab label={<><span id="discrete-slider-always" className={`${classes.tabText} text-center text-primary`}>
        Semi-monthly
      </span>
      <Typography id="discrete-slider-always" className="text-center" variant="caption">
      { Number(term.smRate * 100).toFixed(1)}%
      </Typography>
      </>} {...a11yProps(1)} />
        </Tabs>
      <br/> <br/>
    {/*   <SwipeableViews
        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
        index={value}
        onChangeIndex={handleChangeIndex}
      > */}
      <>
        <TabPanel value={value} index={0} dir={theme.direction}>
        <PayTerm
            STEP={1}
            MIN={1}
            MAX={term.weeklyTerm}
            type="Weeks"
            values={values.term}
            setValues={handlePayTerms('term')}
           />
           <br/> <br/>

                <Slider
            STEP={500}
            MIN={1000}
            MAX={term.maxAmount}
            values={values.principal}
            handleValue={handleAmount}
           />
        </TabPanel>
        <TabPanel value={value} index={1} dir={theme.direction}>
        <PayTerm
            STEP={1}
            MIN={1}
            MAX={term.smTerm}
            type="Semi-Monthly Period/s"
            values={values.term}
            setValues={handlePayTerms('term')}
           />
        <br/> <br/>

                <Slider
            STEP={500}
            MIN={1000}
            MAX={term.maxAmount}
            values={values.principal}
            handleValue={handleAmount}
           />
        </TabPanel>
      {/* </SwipeableViews> */}
      </>
    </div>
  );
}
